export const BIRTH_YEAR_RANGE_OPTIONS = [
  { value: "1954 eller tidigare", name: "1954 eller tidigare" },
  { value: "1955-1959", name: "1955–1959" },
  { value: "1960-1964", name: "1960–1964" },
  { value: "1965-1969", name: "1965–1969" },
  { value: "1970-1974", name: "1970–1974" },
  { value: "1975-1979", name: "1975–1979" },
  { value: "1980-1984", name: "1980–1984" },
  { value: "1985-1989", name: "1985–1989" },
  { value: "1990-1994", name: "1990–1994" },
  { value: "1995-1999", name: "1995–1999" },
  { value: "2000-2004", name: "2000–2004" },
  { value: "2005-2010", name: "2005–2010" },
  { value: "2011 eller senare", name: "2011 eller senare" },
];
